var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngrysmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C28.9412 1 37 9.05888 37 19C37 28.9412 28.9412 37 19 37C9.05888 37 1 28.9412 1 19C1 9.05888 9.05888 1 19 1Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27C12 25 14.5817 23 19 23C23.4182 23 26 25 27 27",
    stroke: "#5E5E5E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C14.1046 17 15 15.6569 15 14C15 12.3431 14.1046 11 13 11C11.8954 11 11 12.3431 11 14C11 15.6569 11.8954 17 13 17Z",
    fill: "#5E5E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12L10 10",
    stroke: "#5E5E5E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17C26.1046 17 27 15.6569 27 14C27 12.3431 26.1046 11 25 11C23.8954 11 23 12.3431 23 14C23 15.6569 23.8954 17 25 17Z",
    fill: "#5E5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12L28 10",
    stroke: "#5E5E5E",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngrysmile);
export default __webpack_public_path__ + "static/media/angrysmile.dad30a99.svg";
export { ForwardRef as ReactComponent };